var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":"","mt-13":""}},[_c('p',{staticClass:"font-weight-bold text-center"},[_vm._v(" Ваша учетная запись успешно активирована! ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }